// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartActionsStyles } from "@keller/Overrides/Widgets/Cart/CartActions";
import { createLinkIconStyles } from "@keller/XDL/Utilities/sharedStyles";
import xScreen from "@keller/XDL/Utilities/xScreen";
import { css } from "styled-components";
import { constants } from "@keller/XDL/constants";

cartActionsStyles.cancelApprovalButton = {
    ...createLinkIconStyles("Save"),
    css: css`
        margin-right: 12px;
        flex-shrink: 0;
        ${xScreen("lte", constants.cartLine.breakpoints.md)} {
            margin-right: 0;
        }
    `,
};

cartActionsStyles.discardEditLink = {
    ...createLinkIconStyles("X"),
    css: css`
        margin-right: 12px;
        flex-shrink: 0;
        ${xScreen("lte", constants.cartLine.breakpoints.md)} {
            margin-right: 0;
        }
    `,
};
